<template>
  <div>
    <!--begin::Header-->
    <div class="card-header border-0 py-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label font-weight-bolder text-dark">
          Your Products
        </span>
        <br />
        <span class="text-muted mt-3 font-weight-bold font-size-sm">
          includes job marketing products and own contracts
        </span>
      </h3>
      <div class="card-toolbar"></div>
      <!--end::Header-->
      <!--begin::Body-->
      <div class="card-body py-0">
        <!--begin::Table-->
        <div class="table-responsive">
          <table
            v-if="products.length > 0"
            id="kt_advance_table_widget_4"
            class="table table-head-custom table-vertical-center"
          >
            <thead>
              <tr class="text-left">
                <th class="pl-0" style="width: 30px"></th>
                <th class="pl-0">Product</th>
                <th>Type</th>
                <th>Price</th>
                <th>Processing time</th>
              </tr>
            </thead>
            <tbody>
              <basket-product
                v-for="(product, i) in products"
                :product="product"
                :currency="currency"
                @remove="removeFromBasket"
                v-bind:key="i"
              />
            </tbody>
          </table>
          <p class="alert alert-light" v-if="products.length === 0">
            Your basket is empty.
          </p>
          <div>
            <div class="summary-container">
              <h3 v-if="totalVonqPriceAmount && wallet">
                Order Total: {{ currency.symbol
                }}{{ priceFormat(totalVonqPriceAmount) }}
                <span v-if="currency.code !== wallet.balance.currency"
                  >({{ currencySymbol(wallet.balance.currency)
                  }}{{
                    priceFormat(
                      totalVonqPriceAmountForCurrency(wallet.balance.currency)
                    )
                  }})
                </span>
              </h3>
            </div>
          </div>
        </div>
        <!--end::Table-->
      </div>
      <!--end::Body-->
    </div>
  </div>
</template>

<script>
import { BasketService } from "@/core/services/basket.service";

import BasketProduct from "@/view/components/checkout/BasketProduct.vue";
import ProductsMixin from "@/view/mixins/ProductsMixin";
import PriceMixin from "@/view/mixins/PriceMixin";
import CurrencyMixin from "@/view/mixins/CurrencyMixin";

export default {
  name: "Basket",
  components: {
    BasketProduct
  },
  emits: ["products-update"],
  mixins: [ProductsMixin, PriceMixin, CurrencyMixin],
  props: { wallet: Object },
  data() {
    return {
      pProducts: [],
      displayOptions: {},
      paymentMethod: null,
      paymentMethods: [
        { value: null, text: "Please select", selected: true },
        { value: "wallet", text: "Wallet" },
        { value: "purchase_order", text: "Purchase Order" },
        { value: "ats_managed", text: "ATS Managed" }
      ]
    };
  },
  computed: {
    products: {
      get: function() {
        return this.pProducts;
      },
      set: function(newValue) {
        this.pProducts = newValue;
        this.$emit("products-update", this.pProducts);
      }
    },
    amount() {
      return this.totalVonqPriceAmount > this.wallet?.balance.amount
        ? Math.floor(
            this.totalVonqPriceAmountForCurrency(
              this.wallet?.balance.currency
            ) * 100
          ) - Math.floor(this.wallet?.balance.amount * 100)
        : "";
    },
    canOrder() {
      const hasProductsInBasket = this.products.length > 0;
      const isAtsManaged = this.paymentMethod == "ats_managed";
      const canOrderWithWallet =
        this.paymentMethod == "wallet" &&
        this.wallet?.balance.amount >=
          this.totalVonqPriceAmountForCurrency(this.wallet?.balance.currency);
      const canOrderWithPurchaseOrder =
        this.paymentMethod == "purchase_order" &&
        this.wallet?.hasBillingDetails;
      return (
        hasProductsInBasket &&
        (isAtsManaged || canOrderWithWallet || canOrderWithPurchaseOrder)
      );
    },
    shouldTopUp() {
      return (
        this.wallet?.balance.amount >=
        this.totalVonqPriceAmountForCurrency(this.wallet?.balance.currency)
      );
    }
  },
  methods: {
    orderCampaign() {
      this.$emit("ordercampaign", this.paymentMethod, this.wallet);
    },
    removeFromBasket(productId) {
      if (!productId) {
        return;
      }
      console.log("removeProduct called with ", productId);
      BasketService.removeProduct(productId);
      this.products = BasketService.getProducts();
      this.$forceUpdate();
    }
  },
  async mounted() {
    this.products = BasketService.getProducts();
    this.displayOptions = BasketService.getDisplayOptions();
  },
  created: function() {
    window.addEventListener("message", this.onWindowMessage);
  },
  destroyed: function() {
    window.removeEventListener("message", this.onWindowMessage);
  }
};
</script>

<style scoped>
.full-width {
  width: 100%;
}

.payment-iframe {
  width: 100%;
  height: 600px;
  border: none;
  margin-top: 10px;
}

.summary-container {
  text-align: right;
  padding: 10px;
}
</style>
